module.exports = "/packs/images/mission-values/juul-pods@3x-5b2714579c95c8188f9db44425136653.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mission-values/juul-pods@3x.jpg
// module id = 1781
// module chunks = 0